export enum ScopeEnum {
  PUBLIC = 'PUBLIC',
  PRIVATE = 'PRIVATE',
  AUTH = 'AUTH'
}